import { Injectable, inject } from '@angular/core';

import { distinctUntilChanged } from 'rxjs';
import { datadogRum } from '@datadog/browser-rum';

import { ConsentTextId } from '@fcom/common/interfaces';
import { ConsentService } from '@fcom/common/login';

@Injectable({ providedIn: 'root' })
export class DatadogReplayConsentService {
  private consentService = inject(ConsentService);

  /**
   * Gates Session Replay on analytics consent. Until consent is stored the status is `false`, so
   * replay stays off; the subscription is kept open (no `take(1)`) so that once the customer stores
   * their choice we react — starting replay if accepted, stopping it if declined or later withdrawn.
   */
  gateReplayOnConsent(): void {
    this.consentService
      .getCookieConsentStatusById(ConsentTextId.COOKIE_ANALYTICS)
      .pipe(distinctUntilChanged())
      .subscribe((granted) =>
        granted ? datadogRum.startSessionReplayRecording() : datadogRum.stopSessionReplayRecording()
      );
  }
}
